import user from './user';
import notification from './notification';

export default {
  user,
  notification
}